import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+500',
    label: 'familias conectadas'
  }, {
    value: '4',
    label: 'Libros digitales'
  }, {
    value: '4.9/5',
    label: 'calificación ⭐'
  }, {
    value: '7',
    label: 'Bonos incluidos'
  }];
  return <div className="bg-navy-900/90 border-y border-purple-900/30 py-6 relative z-20 backdrop-blur-md" data-id="element-241">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-242">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-0 md:divide-x md:divide-purple-900/50" data-id="element-243">
          {stats.map((stat, index) => <div key={index} className="flex items-center gap-2.5 justify-center md:px-4 hero-animate-4" data-id="element-244">
              <span className="text-xl md:text-3xl font-bold font-poppins text-gradient-cosmic" data-id="element-245">
                {stat.value}
              </span>
              <span className="text-[11px] md:text-sm text-slate-400 font-medium leading-tight max-w-[90px]" data-id="element-246">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}